import React from 'react';

function BlogCard({ post, onViewPost }) {
  return (
    <div className="card flex flex-col overflow-hidden">
      {post.fields.featuredImage && (
        <img
          src={post.fields.featuredImage.fields.file.url}
          alt={post.fields.title}
          className="w-full h-48 object-cover"
          onError={e => { e.target.onerror = null; e.target.src = 'https://placehold.co/600x400/cccccc/ffffff?text=Image+Not+Found'; }}
        />
      )}
      <div className="p-6 flex flex-col flex-grow">
        <h2 className="text-xl font-semibold text-gray-900 mb-2 hover:text-indigo-600 transition-colors">
          <a href="#" onClick={e => { e.preventDefault(); onViewPost(post); }}>
            {post.fields.title}
          </a>
        </h2>
        <p className="text-gray-600 text-sm mb-3">
          {new Date(post.sys.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>
        <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-grow">
          {post.fields.excerpt || (post.fields.content ? post.fields.content.substring(0, 100) + '...' : 'No excerpt available.')}
        </p>
        <button
          onClick={() => onViewPost(post)}
          className="mt-auto text-indigo-600 hover:text-indigo-800 font-medium self-start"
        >
          Read more <span aria-hidden="true">&rarr;</span>
        </button>
      </div>
    </div>
  );
}

export default BlogCard; 